import React, { createContext, useContext, useState, useCallback } from 'react';

interface OrderActionsContextType {
  triggerSaveOrder?: () => void;
  setSaveOrderHandler: (handler: (() => void) | null) => void;
}

const OrderActionsContext = createContext<OrderActionsContextType | undefined>(undefined);

export const useOrderActions = () => {
  const context = useContext(OrderActionsContext);
  if (!context) {
    throw new Error('useOrderActions must be used within an OrderActionsProvider');
  }
  return context;
};

interface OrderActionsProviderProps {
  children: React.ReactNode;
}

export const OrderActionsProvider: React.FC<OrderActionsProviderProps> = ({ children }) => {
  const [saveOrderHandler, setSaveOrderHandlerState] = useState<(() => void) | null>(null);

  const setSaveOrderHandler = useCallback((handler: (() => void) | null) => {
    setSaveOrderHandlerState(() => handler);
  }, []);

  const triggerSaveOrder = useCallback(() => {
    if (saveOrderHandler) {
      saveOrderHandler();
    } else {
      console.warn("Save order handler not set.");
    }
  }, [saveOrderHandler]);

  return (
    <OrderActionsContext.Provider value={{ triggerSaveOrder, setSaveOrderHandler }}>
      {children}
    </OrderActionsContext.Provider>
  );
};
